import { encodeHTMLEntities } from '@ds/swymkit/utils'
import { defineStore } from 'pinia'

import { fetchDerivedTypes } from '~/entities/container/community/api/communities'

import type { IDerivedTypeData } from '~/features-shared/content-derived-type/interfaces/derived-types'
import { createStyles, derivedTypeACLParser } from '~/features-shared/content-derived-type/utils/derived-types'
import type { SUBJECT_6W_URI } from '~/features-shared/libs/interfaces/entity'
import { logger } from '~/features-shared/libs/utils/logger'

export const useDerivedTypesStore = defineStore('derived-types', () => {
  // #region STATE
  const derivedTypes = reactive<Map<SUBJECT_6W_URI, IDerivedTypeData>>(new Map())
  const derivedTypesByCommunity = reactive<Map<SUBJECT_6W_URI, IDerivedTypeData[]>>(new Map())
  // #endregion

  // #region ACTIONS
  const fetchDerivedTypesForCommunity = async (subject_uri: SUBJECT_6W_URI) => {
    try {
      if (!derivedTypesByCommunity.has(subject_uri)) {
        const communityId = subject_uri.split(':')
          .pop() as string
        const dt = (await fetchDerivedTypes(communityId)).result

        const allDerivedTypes: IDerivedTypeData[] = []

        dt.forEach((derivedType) => {
          const dtObj: IDerivedTypeData = {
            parent: derivedType.parent,
            color: derivedType.color,
            icon: derivedType.icon,
            id: derivedType.id,
            label: encodeHTMLEntities(derivedType.label),
            _acl: derivedTypeACLParser(derivedType.acl),
            media_type: derivedType.media_type,
          }
          createStyles(dtObj)
          derivedTypes.set(derivedType.id, dtObj)
          allDerivedTypes.push(dtObj)
        })

        derivedTypesByCommunity.set(subject_uri, allDerivedTypes)
      }
    }
    catch (err) {
      logger.error(err)
    }
  }
  // #endregion

  return {
    derivedTypes,
    derivedTypesByCommunity,

    fetchDerivedTypesForCommunity,
  }
})
